export type CaptchaState = {
    done: boolean;
};

export const captchaInitialState: CaptchaState = {
    done: true,
};
